import {
  LOAD_DOCUMENTS_PENDING,
  LOAD_DOCUMENTS_FULFILLED,
  LOAD_DOCUMENTS_REJECTED,
  LOAD_NEW_DOCUMENTS_PENDING,
  LOAD_NEW_DOCUMENTS_FULFILLED,
  LOAD_NEW_DOCUMENTS_REJECTED,
  LOAD_TSB_DOCUMENTS_PENDING,
  LOAD_TSB_DOCUMENTS_FULFILLED,
  LOAD_TSB_DOCUMENTS_REJECTED,
  LOAD_NEW_TSB_DOCUMENTS_PENDING,
  LOAD_NEW_TSB_DOCUMENTS_FULFILLED,
  LOAD_NEW_TSB_DOCUMENTS_REJECTED,
  LOAD_DASHBOARD_TSB_DOCUMENTS_PENDING,
  LOAD_DASHBOARD_TSB_DOCUMENTS_FULFILLED,
  LOAD_DASHBOARD_TSB_DOCUMENTS_REJECTED,
  LOAD_DOCUMENTS_UPLOAD_PENDING,
  LOAD_DOCUMENTS_UPLOAD_FULFILLED,
  LOAD_DOCUMENTS_UPLOAD_REJECTED,
  LOAD_NEW_DOCUMENTS_UPLOAD_PENDING,
  LOAD_NEW_DOCUMENTS_UPLOAD_FULFILLED,
  LOAD_NEW_DOCUMENTS_UPLOAD_REJECTED,
  LOAD_DOCUMENT_MODELS_PENDING,
  LOAD_DOCUMENT_MODELS_FULFILLED,
  LOAD_DOCUMENT_MODELS_REJECTED,
  LOAD_DOCUMENT_TYPES_PENDING,
  LOAD_DOCUMENT_TYPES_FULFILLED,
  LOAD_DOCUMENT_TYPES_REJECTED,
  LOAD_DOCUMENT_LANGUAGES_PENDING,
  LOAD_DOCUMENT_LANGUAGES_FULFILLED,
  LOAD_DOCUMENT_LANGUAGES_REJECTED,
  LOAD_DOCUMENT_CATEGORIES_PENDING,
  LOAD_DOCUMENT_CATEGORIES_FULFILLED,
  LOAD_DOCUMENT_CATEGORIES_REJECTED,
  LOAD_ADMIN_DOCUMENT_MODELS_PENDING,
  LOAD_ADMIN_DOCUMENT_MODELS_FULFILLED,
  LOAD_ADMIN_DOCUMENT_MODELS_REJECTED,
  LOAD_TSB_DOCUMENT_LANGUAGES_PENDING,
  LOAD_TSB_DOCUMENT_LANGUAGES_FULFILLED,
  LOAD_TSB_DOCUMENT_LANGUAGES_REJECTED,
  POST_DOCUMENT_PENDING,
  POST_DOCUMENT_FULFILLED,
  POST_DOCUMENT_REJECTED,
  PUT_DOCUMENT_PENDING,
  PUT_DOCUMENT_FULFILLED,
  PUT_DOCUMENT_REJECTED,
  PUT_DOCUMENT_FILE_PENDING,
  PUT_DOCUMENT_FILE_FULFILLED,
  PUT_DOCUMENT_FILE_REJECTED,
  PUT_DOCUMENT_EXTERNAL_FILE_PENDING,
  PUT_DOCUMENT_EXTERNAL_FILE_FULFILLED,
  PUT_DOCUMENT_EXTERNAL_FILE_REJECTED,
  DELETE_DOCUMENT_PENDING,
  DELETE_DOCUMENT_FULFILLED,
  DELETE_DOCUMENT_REJECTED,
  DELETE_DOCUMENT_FILE_PENDING,
  DELETE_DOCUMENT_FILE_FULFILLED,
  DELETE_DOCUMENT_FILE_REJECTED,
  DELETE_DOCUMENT_EXTERNAL_FILE_PENDING,
  DELETE_DOCUMENT_EXTERNAL_FILE_FULFILLED,
  DELETE_DOCUMENT_EXTERNAL_FILE_REJECTED,
  CLEAR_DOCUMENTS_MESSAGES,
} from '../actions/documents'
import i18n from 'i18next'

export default function documents(state = {}, action) {
  switch (action.type) {
    case LOAD_DOCUMENTS_PENDING:
    case LOAD_NEW_DOCUMENTS_PENDING:
    case LOAD_TSB_DOCUMENTS_PENDING:
    case LOAD_NEW_TSB_DOCUMENTS_PENDING:
    case LOAD_DOCUMENTS_UPLOAD_PENDING:
    case LOAD_NEW_DOCUMENTS_UPLOAD_PENDING:
    case LOAD_DOCUMENT_MODELS_PENDING:
    case LOAD_DOCUMENT_TYPES_PENDING:
    case LOAD_DOCUMENT_LANGUAGES_PENDING:
    case LOAD_DOCUMENT_CATEGORIES_PENDING:
    case LOAD_ADMIN_DOCUMENT_MODELS_PENDING:
    case LOAD_TSB_DOCUMENT_LANGUAGES_PENDING:
    case POST_DOCUMENT_PENDING:
    case PUT_DOCUMENT_PENDING:
    case PUT_DOCUMENT_FILE_PENDING:
    case PUT_DOCUMENT_EXTERNAL_FILE_PENDING:
    case DELETE_DOCUMENT_PENDING:
    case DELETE_DOCUMENT_FILE_PENDING:
    case DELETE_DOCUMENT_EXTERNAL_FILE_PENDING:
      return {
        ...state,
        isLoading: true,
        successMessage: null,
        errorMessage: null,
      }
    case LOAD_DOCUMENTS_REJECTED:
    case LOAD_NEW_DOCUMENTS_REJECTED:
    case LOAD_TSB_DOCUMENTS_REJECTED:
    case LOAD_NEW_TSB_DOCUMENTS_REJECTED:
    case LOAD_DOCUMENTS_UPLOAD_REJECTED:
    case LOAD_NEW_DOCUMENTS_UPLOAD_REJECTED:
    case LOAD_DOCUMENT_MODELS_REJECTED:
    case LOAD_DOCUMENT_TYPES_REJECTED:
    case LOAD_DOCUMENT_LANGUAGES_REJECTED:
    case LOAD_DOCUMENT_CATEGORIES_REJECTED:
    case LOAD_ADMIN_DOCUMENT_MODELS_REJECTED:
    case LOAD_TSB_DOCUMENT_LANGUAGES_REJECTED:
    case POST_DOCUMENT_REJECTED:
    case PUT_DOCUMENT_REJECTED:
    case PUT_DOCUMENT_FILE_REJECTED:
    case PUT_DOCUMENT_EXTERNAL_FILE_REJECTED:
    case DELETE_DOCUMENT_REJECTED:
    case DELETE_DOCUMENT_FILE_REJECTED:
    case DELETE_DOCUMENT_EXTERNAL_FILE_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }
    case LOAD_DOCUMENTS_FULFILLED:
      const documents = state?.documents || []
      const newDocumentsIds = action.payload.data?.map((item) => item.id)
      const difference = documents.filter((x) => !newDocumentsIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        documents: difference,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_DOCUMENTS_FULFILLED:
      return {
        ...state,
        documents: action.payload.data,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_TSB_DOCUMENTS_FULFILLED:
      const tsbDocuments = state?.tsbDocuments || []
      const newTsbDocumentsIds = action.payload.data?.map((item) => item.id)
      const tsbDifference = tsbDocuments.filter((x) => !newTsbDocumentsIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        tsbDocuments: tsbDifference,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_TSB_DOCUMENTS_FULFILLED:
      return {
        ...state,
        tsbDocuments: action.payload.data,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_DASHBOARD_TSB_DOCUMENTS_PENDING:
      return {
        ...state,
        dashboardTsbLoading: true,
        dashboardTsbError: null,
      }
    case LOAD_DASHBOARD_TSB_DOCUMENTS_REJECTED:
      return {
        ...state,
        dashboardTsbLoading: false,
        dashboardTsbError: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }
    case LOAD_DASHBOARD_TSB_DOCUMENTS_FULFILLED:
      return {
        ...state,
        dashboardTsbDocuments: action.payload.data,
        dashboardTsbLoading: false,
      }
    case LOAD_DOCUMENTS_UPLOAD_FULFILLED:
      const documentsUpload = state?.documentsUpload || []
      const newDocumentsUploadIds = action.payload.data?.map((item) => item.id)
      const documentsUploadDifference = documentsUpload.filter((x) => !newDocumentsUploadIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        documentsUpload: documentsUploadDifference,
        canLoadMoreDocumentsUpload: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_DOCUMENTS_UPLOAD_FULFILLED:
      return {
        ...state,
        documentsUpload: action.payload.data,
        canLoadMoreDocumentsUpload: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_DOCUMENT_MODELS_FULFILLED:
      return {
        ...state,
        documentModels: action.payload.data?.map((item) => item.model),
        isLoading: false,
      }
    case LOAD_DOCUMENT_TYPES_FULFILLED:
      return {
        ...state,
        documentTypes: action.payload.data?.sort((a, b) => a.name?.localeCompare(b.name)),
        isLoading: false,
      }
    case LOAD_DOCUMENT_LANGUAGES_FULFILLED:
      return {
        ...state,
        documentLanguages: action.payload.data,
        isLoading: false,
      }
    case LOAD_TSB_DOCUMENT_LANGUAGES_FULFILLED:
      return {
        ...state,
        tsbDocumentLanguages: action.payload.data,
        isLoading: false,
      }
    case LOAD_DOCUMENT_CATEGORIES_FULFILLED:
      return {
        ...state,
        documentCategories: action.payload,
        isLoading: false,
      }
    case LOAD_ADMIN_DOCUMENT_MODELS_FULFILLED:
      return {
        ...state,
        adminDocumentModels: action.payload,
        isLoading: false,
      }
    case POST_DOCUMENT_FULFILLED:
      const existingDocumentsUpload = state?.documentsUpload || []

      return {
        ...state,
        documentsUpload: [action.payload, ...existingDocumentsUpload],
        isLoading: false,
        successMessage: i18n.t('document_context.document_created_successfully'),
      }
    case PUT_DOCUMENT_FULFILLED:
      const updatedDocumentsUpload = state?.documentsUpload.map((item) => (item.id === action.payload.id ? action.payload : item))

      return {
        ...state,
        documentsUpload: updatedDocumentsUpload,
        isLoading: false,
        successMessage: i18n.t('document_context.document_updated_successfully'),
      }
    case PUT_DOCUMENT_FILE_FULFILLED:
      const updatedDocumentsUploadFiles = state?.documentsUpload.map((item) =>
        item.id === action.meta.documentId
          ? {
              ...item,
              files: item.files.map((f) => (f.id === action.payload.id ? action.payload : f)),
              isActive: item.files.map((f) => (f.id === action.payload.id ? action.payload : f)).some((d) => d.isActive),
            }
          : item,
      )

      return {
        ...state,
        documentsUpload: updatedDocumentsUploadFiles,
        isLoading: false,
        successMessage: i18n.t('document_context.document_updated_successfully'),
      }
    case PUT_DOCUMENT_EXTERNAL_FILE_FULFILLED:
      const updatedDocumentsUploadExternalFiles = state?.documentsUpload.map((item) =>
        item.id === action.meta.documentId
          ? {
              ...item,
              externalDocuments: item.externalDocuments.map((f) => (f.id === action.payload.id ? action.payload : f)),
              isActive: item.externalDocuments.map((f) => (f.id === action.payload.id ? action.payload : f)).some((d) => d.isActive),
            }
          : item,
      )

      return {
        ...state,
        documentsUpload: updatedDocumentsUploadExternalFiles,
        isLoading: false,
        successMessage: i18n.t('document_context.document_updated_successfully'),
      }
    case DELETE_DOCUMENT_FULFILLED:
      const remainingDocuments = state?.documentsUpload.filter((item) => item.id !== action.meta.id)

      return {
        ...state,
        documentsUpload: remainingDocuments,
        isLoading: false,
        successMessage: i18n.t('document_context.document_deleted_successfully'),
      }
    case DELETE_DOCUMENT_FILE_FULFILLED:
      const remainingDocumentsUploadFiles = state?.documentsUpload.map((item) =>
        item.id === action.meta.documentId ? { ...item, files: item.files.filter((f) => f.id !== action.meta.fileId) } : item,
      )

      return {
        ...state,
        documentsUpload: remainingDocumentsUploadFiles,
        isLoading: false,
        successMessage: i18n.t('document_context.document_file_deleted_successfully'),
      }
    case DELETE_DOCUMENT_EXTERNAL_FILE_FULFILLED:
      const remainingDocumentsUploadExternalFiles = state?.documentsUpload.map((item) =>
        item.id === action.meta.documentId ? { ...item, externalDocuments: item.externalDocuments.filter((f) => f.id !== action.meta.fileId) } : item,
      )

      return {
        ...state,
        documentsUpload: remainingDocumentsUploadExternalFiles,
        isLoading: false,
        successMessage: i18n.t('document_context.document_file_deleted_successfully'),
      }
    case CLEAR_DOCUMENTS_MESSAGES: {
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
        dashboardTsbError: null,
      }
    }
    default:
      return state
  }
}

